var pageOrder = require('./pageOrder');

var config = {
  gatsby: {
    pathPrefix: '/',
    siteUrl: 'https://www.speik.com',
    gaTrackingId: null
  },
  header: {
    logo: '/LogoTab.png',
    title: 'Docs',
    helpUrl: '',
    tweetText: '',
    links: [{ text: '', link: '' }]
  },
  sidebar: {
    forcedNavOrder: pageOrder,
    links: [{ text: '', link: '' }]
  },
  siteMetadata: {
    title: 'Integration Guide | Speik',
    docsLocation: '',
    description: '',
    ogImage: null,
    favicon: '/LogoTab.png'
  }
};

module.exports = config;
